module.exports = __webpack_public_path__ + "static/media/mobile2.ac4ba7d9.png";